$(document).ready(function () {
    let magSwatches = document.querySelectorAll('.block-magazines_item ');
    magSwatches.forEach( function (item){
        item.addEventListener('click', function (e) {
            if (!item.classList.contains('active')){
                document.querySelector('#page-flip').classList.add('loading');
                magSwatches.forEach( function (it){
                    it.classList.remove('active');
                })
                item.classList.add('active');
                let coverUrl = e.target.closest('.block-magazines_item').dataset.cover.trim();
                let pageUrl = e.target.closest('.block-magazines_item').dataset.page.trim();
                document.querySelector('#page-flip #p1>div').style.backgroundImage = `url(${coverUrl})`;
                document.querySelector('#page-flip #p2>div').style.backgroundImage = `url(${pageUrl})`;
                setTimeout(function () {
                    document.querySelector('#page-flip').classList.remove('loading');
                }, 300);
            }
        })
    })
})
